// Generator-discovered file route for the domains panel (Module O). Component
// lives in `src/ad/routes/domains.tsx` (Module K / K3).
import { createFileRoute } from '@tanstack/react-router';
import { DomainsRouteComponent } from '@/ad/routes/domains';

export const Route = createFileRoute('/_authenticated/ad/domains')({
  component: DomainsRouteComponent,
});
